<template>
  <div
    class="btn"
    :style="{ top: 65 - index * 10 + '%' }"
    @click="linkCheck(item)"
    v-for="(item, index) in data"
    :key="index"
  >
    <img
      :src="
        item.icon?.length ? item.icon[0].response.data.url : item.iconDefault
      "
    />
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import routers from "@/hooks/routers";
import { Dialog } from "vant";
import { useStore } from "vuex";

export default defineComponent({
  name: "FixedBtn",
  props: ["data"],
  setup() {
    const { linkTo, linkTo_H5 } = routers();
    const store = useStore();

    function linkCheck(data) {
      if (data.template) {
        if (data.template === "旧衣服回收") {
          linkTo("/Yuyue");
        } else if (data.template === "地址管理") {
          linkTo("/Addresses");
        } else if (data.template === "上门地区") {
          linkTo("/scope");
        } else if (data.template === "回收与处理") {
          linkTo("/way");
        } else if (data.template === "证书") {
          link_zs();
        } else if (data.template === "分享") {
          link_fx();
        } else if (data.template === "客服") {
          linkTo_H5(
            "https://g5gg6x2hoblhg.cschat.antcloud.com.cn/index.htm?tntInstId=7Lo_GpVs&scene=SCE00165722"
          );
        } else if (data.template === "登录/注册") {
          linkTo("/Login");
        } else if (data.template === "全不是" && data.other === "h5") {
          linkTo_H5(data.link);
        } else if (
          data.template === "全不是" &&
          data.other === "支付宝小程序"
        ) {
          let flag =
            /\/pages\/index\/index|\/pages\/yuyue\/yuyue|\/pages\/qiandao\/qiandao|\/pages\/jilu\/jilu|\/pages\/my\/my/.test(
              data.link
            );
          flag
            ? my.switchTab({ url: data.link })
            : my.navigateTo({ url: data.link });
        } else if (data.template === "全不是" && data.other === "微信小程序") {
          let flag =
            /\/pages\/index\/index|\/pages\/yuyue\/yuyue|\/pages\/qiandao\/qiandao|\/pages\/quanzi\/quanzi|\/pages\/jilu\/jilu|\/pages\/my\/my/.test(
              data.link
            );
          flag
            ? wx.miniProgram.switchTab({ url: data.link })
            : wx.miniProgram.navigateTo({ url: data.link });
        } else if (data.template === "全不是" && data.other === "自定义") {
          Dialog.alert({
            message: "暂无设置自定义跳转",
            theme: "",
            confirmButtonColor: "#101010",
          });
        }
      } else {
        Dialog.alert({
          message: "暂无设置跳转",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    /**
     * @description: 证书跳转
     * @param {*}
     * @return {*}
     */
    function link_zs() {
      let data = store.state.partnerConfig?.basic;
      if (data.certificate === "0") {
        linkTo("/Certificate");
      } else {
        Dialog.alert({
          message: "暂无开启证书跳转",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    /**
     * @description: 分享跳转
     * @param {*}
     * @return {*}
     */
    function link_fx() {
      let data = store.state.partnerConfig?.basic;
      if (data.share_type) {
        if (data.share_type === "生成分享海报") {
          linkTo("/Poster");
        } else if (data.share_type === "合作方自带集成sdk") {
          if (data.share_content) {
            linkTo_H5(data.share_content);
          } else {
            Dialog.alert({
              message: "暂无设置sdk跳转地址",
              theme: "",
              confirmButtonColor: "#101010",
            });
          }
        }
      } else {
        Dialog.alert({
          message: "暂无开启分享跳转",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    onMounted(() => {
      // console.dir(props.index);
    });

    return { linkCheck };
  },
});
</script>

<style lang="scss" scoped>
.btn {
  position: fixed;
  top: 60%;
  right: 0.1rem;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 50);
  border-radius: 100%;
  text-align: center;
  color: #e8c693;
  width: 0.5rem;
  height: 0.5rem;
  font-size: 0.12rem;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
